import "./NearbyVenueContent.scss"

import React, { useMemo } from 'react';
import { Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import { findNearestSites } from "../../helpers/nearbySiteFinder";
import ISite from "../../interfaces/ISite";
import { SiteChangeSource } from '../../types/SiteChangeTypes';
import LoadingSpinner from "../loading-spinner/loading-spinner";
import useSiteChange from '../../hooks/useSiteChange';
import { useSelector } from "react-redux";
import { IApplicationState } from "../../store";

interface INearbyVenueContentProps {
    onSiteChange?: (site: ISite) => void;
}

const NearbyVenueContent: React.FC<INearbyVenueContentProps> = ({ onSiteChange }) => {
    const { changeSite } = useSiteChange();
    
    const sites = useSelector((state: IApplicationState) => state.sites.sites);
    const sitesLoading = useSelector((state: IApplicationState) => state.sites.sitesLoading);
    const sitesLoaded = useSelector((state: IApplicationState) => state.sites.sitesLoaded);
    const location = useSelector((state: IApplicationState) => state.location.location);

    const nearbyVenues = useMemo(() => {
        return findNearestSites(sites, location, 3);
    }, [sites, location]);

    const onClickVenueTile = async (clickedSite: ISite) => {
        await changeSite(clickedSite, { source: SiteChangeSource.VenueWidget }, false, true, true);
        
        // Notify parent if callback provided
        if (onSiteChange) {
            onSiteChange(clickedSite);
        }
    };

    if (sitesLoading) {
        return <LoadingSpinner />;
    } else if (
        !sitesLoading &&
        (!sitesLoaded || sites === undefined || sites?.length === 0)
    ) {
        return <WarningOutlined style={{ color: 'red', fontSize: '32px', width:'100%', justifyContent:'center'}} />;
    }
    else {
        return (
            <>
                {nearbyVenues?.map(x => (
                    <button key={x.site.siteId} className="nearby-venue-tile" onClick={() => onClickVenueTile(x.site)}>
                        <div className="nearby-venue-info">
                            <Typography.Title level={2} className="nearby-venue-title">{x.site.name?.toUpperCase()}</Typography.Title>
                            <div className="nearby-venue-details">
                                <div className="nearby-venue-address">
                                    <Typography.Text>{x.site.siteMetadata?.addressLine1}</Typography.Text>
                                    <Typography.Text>{x.site.siteMetadata?.addressLine2}</Typography.Text>
                                    <Typography.Text>{x.site.siteMetadata?.addressLine3}</Typography.Text>
                                </div>
                                <div className="nearby-venue-distance">
                                    <Typography.Text>
                                        {x.distanceInMeters != null
                                            ? `${(x.distanceInMeters / 1000).toFixed(1)} km`
                                            : '-'}
                                    </Typography.Text>
                                </div>
                            </div>
                        </div>
                    </button>
                ))}
            </>
        );
    }
};

export default NearbyVenueContent;
